module.exports = __webpack_public_path__ + "media/common/images/badges/active/demon_administrativy-0019d284545a212313e09627ca067921.svg";